import React, { useState } from "react";
import "../css/delivery.scss";
import { Link } from "react-router-dom";

function Delivery() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const faqItems = [
    {
      id: "what-are-the-2025-holiday-shipping-deadlines",
      question: "What are the 2025 holiday shipping deadlines?",
      answer: (
        <p>
          Please visit our{" "}
          <Link onClick={toTop} to="/shipping" title="Holiday Shipping">
            2025 Holiday Shipping
          </Link>{" "}
          page for full list of dates.
        </p>
      ),
    },
    {
      id: "when-will-my-order-ship",
      question: "When will my order ship?",
      answer: (
        <>
          <p>
            It takes one business day to receive and fulfill your order.
            However, if you submit your order by 2pm CST Monday through Friday,
            your order will typically be shipped out the same day. Please note
            that the shipping method selected at checkout only applies to the
            time in transit. The time of transit starts when the package is
            picked up by the carrier, not once the order is submitted. Orders
            that contain special care products typically only ship from our
            facility Monday – Wednesday. (except during the colder months). We
            may hold back shipping certain orders and ship earlier in the week
            to ensure product integrity and quality. As soon as our order is
            processed and fulfilled, you will receive tracking details. Tracking
            is updated automatically by the carrier as soon as it is scanned and
            in their possession.
          </p>
          <p>
            <em>
              <strong>
                During the holiday peak season, shipping times may be delayed.
                We will process your order as quickly as possible.
              </strong>
            </em>
          </p>
        </>
      ),
    },
    {
      id: "how-is-shipping-calculated",
      question: "How is shipping calculated?",
      answer: (
        <>
          <p>
            Shipping charges are calculated per ship-to address and based on the
            weight and address location. The shipping costs presented at
            checkout are based on our negotiated rates with UPS and FedEx. You
            can choose your preferred carrier and level of service at checkout.
          </p>
          <p>
            If you need additional assistance or have questions, please contact
            our team at build@dilverbloom.online
          </p>
        </>
      ),
    },
    {
      id: "free-shipping-on-orders-over-129",
      question: "Free Shipping on orders Over $129",
      answer: (
        <p>
          Orders over $129 qualify for FREE Standard Shipping for eligible items
          only (special care items are not eligible for Free Shipping Offers).
          Alaska and Hawaii are not eligible for Free Shipping offers.
        </p>
      ),
    },
    {
      id: "my-order-is-129-why-am-i-being-charged-shipping",
      question: "My order is $129, why am I being charged shipping?",
      answer: (
        <p>
          If your order contains a perishable (special care items), then your
          order doesn’t qualify for Free Standard Shipping. If your order
          contains more than $129 in eligible items and includes a perishable
          (special care) or ineligible product, you are only charged shipping
          for those special care item/s. All orders that have more than $129 in
          eligible items will receive Free Shipping on these items only.
        </p>
      ),
    },
    {
      id: "why-do-i-have-to-pay-additional-shipping-charges-for-perishable-special-care-items-and-non-eligible-items",
      question:
        "Why do I have to pay additional shipping charges for perishable (special care) items and non-eligible items?",
      answer: (
        <p>
          To guarantee that your order arrives in optimum condition, your order
          is packed with ice packs and thermal insulated packaging. During the
          warmest months of the year (typically April through September), we do
          not recommend taking the chance to ship these types of items without
          additional care and packaging. Our policy for these items is more
          relaxed during October through March. Some items that are special care
          during the warmer months are not necessarily special care during the
          colder months of the year.
        </p>
      ),
    },
    {
      id: "how-long-will-it-take-to-get-my-order",
      question: "How long will it take to get my order?",
      answer: (
        <>
          <p>
            <strong>
              ZONE 1 – expect delivery within 1 – 2 business days
              <br />
            </strong>
            Alabama, Arkansas, Colorado, Connecticut, Delaware, Georgia,
            Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maryland,
            Michigan, Minnesota, Mississippi, Missouri, Nebraska, North
            Carolina, New Jersey, New York, Ohio, Oklahoma, Pennsylvania,
            Tennessee, Texas, South Carolina, South Dakota, Virginia, West
            Virginia, Wisconsin
          </p>
          <p>
            <strong>ZONE 2 – expect delivery within 3 – 4 business days</strong>
            <br />
            Arizona, California, Florida, Idaho, Massachusetts, Maine, Montana,
            North Dakota, New Hampshire, New Mexico, Nevada, Oregon, Rhode
            Island, Utah, Vermont, Washington, Wyoming
          </p>
          <p>
            <strong>
              ZONE 3 (AK and HI) – expect delivery within 1 or 2 business days
              based on your selected shipping service
            </strong>
            <br />
            All orders regardless of the order total will calculate the shipping
            cost based on the weight of the package and destination address.
            Alaska and Hawaii will only be able to select 2 Day or Overnight
            Shipping Methods from FedEx and UPS. Free Standard Shipping is not
            available for Zone 3.
          </p>
        </>
      ),
    },
    {
      id: "what-shipping-carriers-do-you-use",
      question: "What shipping carriers do you use?",
      answer: (
        <p>FedEx and UPS. You can select your preferred carrier at checkout.</p>
      ),
    },
    {
      id: "can-i-pickup-my-order-at-dilverblooms-warehouse",
      question: "Can I pickup my order at Dilverbloom's warehouse?",
      answer: (
        <>
          <p>
            We offer curbside pickup at our warehouse for free. Our warehouse is
            in the popular Forest Park Southeast Neighborhood in the Grove at
            1401 South Boyle Avenue, St. Louis, MO 63110.
          </p>
          <p>
            When checking out online, you will have the option to select "pick
            up at Dilverbloom". When your arrive to pick up your order, please
            ring the bell at the double red doors at our Boyle warehouse
            entrance.
          </p>
        </>
      ),
    },
    {
      id: "what-happens-if-i-enter-a-shipping-address-incorrectly-or-my-order-was-sent-to-the-wrong-address",
      question:
        "What happens if I enter a shipping address incorrectly, or my order was sent to the wrong address?",
      answer: (
        <>
          <p>
            If you catch this mistake, please call us as soon as possible at
            888-260-2192 or email us at{" "}
            <a
              href="mailto:build@dilverbloom.online"
              title="mailto:build@dilverbloom.online"
            >
              build@dilverbloom.online
            </a>
            . We will do our best to change the shipping address if it has not
            yet been shipped. If an address correction is needed while your
            package is in transit, a $25 charge will be applied for re-routing.
          </p>
          <p>
            If the package cannot be delivered to the address, your order will
            be returned to our distribution center. If the product returns to
            our distribution center in good condition, we can send the package
            back out to the requested address and charge you only the shipping
            and handling.
          </p>
          <p>
            If the item is in a condition that prevents it from being restocked
            in our inventory, you will be responsible for the charges of a new
            order.
          </p>
        </>
      ),
    },
    {
      id: "can-you-ship-my-order-to-arrive-on-a-saturday",
      question: "Can you ship my order to arrive on a Saturday?",
      answer: (
        <p>
          We are happy to help you with this. Please call us at 888-260-2192 for
          availability and additional fee quote.
        </p>
      ),
    },
    {
      id: "can-i-place-an-order-over-the-phone",
      question: "Can I place an order over the phone?",
      answer: (
        <p>
          We prefer that you submit your order online, but we understand if you
          prefer to speak to a person when placing your order. We are happy to
          accept phone orders at (314)534-6207.
        </p>
      ),
    },
    {
      id: "is-shipping-available-outside-of-the-usa",
      question: "Is shipping available outside of the USA?",
      answer: (
        <p>
          We <em>do not</em> ship outside of the 50 USA states.
        </p>
      ),
    },
  ];

  return (
    <div id="shipping" className="faqs reveal main-open come-in">
      <div className="faqs__outer js-main-toggle">
        <div className="faqs__heading-wrap js-main-toggler">
          <h3 className="type__heading--three faqs__category-heading site-wrap-wide medium-cap reveal come-in">
            Shipping
          </h3>
        </div>
        <div
          className="js-main-togglee faqs__inner"
          style={{ display: "block" }}
        >
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              id={faq.id}
              className={`faq js-toggle ${openFaq === faq.id ? "open" : ""}`}
              onClick={() => toggleFaq(faq.id)}
            >
              <div className="faq__question js-toggler">{faq.question}</div>
              <div className="faq__answer wysiwyg wysiwyg__faq js-togglee">
                {faq.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Delivery;
